import {
	AppPage,
	MimaFilter,
	MimaText,
	MimaDateFilter,
	QuickLinksComponent as QLC,
	BusinessInsightComponent as BIC,
    Searchbar,
    MimaButton,
} from '../../components';
import styles from '../../assets/styles/Commission/Commission.module.scss';
import { AnimatePresence } from 'framer-motion';
import React, { useState } from 'react';
import { Formik } from 'formik';
import { CreateComTypeContainer, SaleSheetUploadContainer } from '../../containers';
import { amountFormatter } from '../../utils/utils';

const Commission = ({
	filterPeriod,
	validationSchema,
	onSubmit,
	loading,
	resetFilter,
    tableType,
    setTableType,
    refresh,
    comTypeModal,
    saleSheetModal,
    showComTypeModal,
    showSaleSheetModal,
    closeModal
}) => {
	const [onReset, setOnReset] = useState(false);

	return (
		<AppPage pageTitle="Sales Commission">
			<MimaText variant="subtitle" mb={2} align="center">
				You are viewing Commission information for {filterPeriod}
			</MimaText>
			<Formik
				initialValues={{
					startDate: '',
					endDate: '',
				}}
				validationSchema={validationSchema}
				onSubmit={onSubmit}
			>
				{({
					handleChange,
					handleBlur,
					handleSubmit,
					setFieldValue,
					values,
					errors,
					touched,
				}) => (
					<MimaFilter
						filterClick={() => {
							setOnReset(false);
							handleSubmit();
						}}
						loading={loading}
						resetClick={() => {
							setOnReset(true);
							resetFilter();
						}}
					>
						<MimaDateFilter
							labelTitle="start date"
							name="startDate"
							value={!onReset ? values.startDate : ''}
							onChange={text => {
								setOnReset(false);
								setFieldValue('startDate', text);
							}}
							onBlur={handleBlur}
							width={18}
							touched={touched.startDate}
							error={errors.startDate}
						/>
						<MimaDateFilter
							labelTitle="End date"
							name="endDate"
							value={!onReset ? values.endDate : ''}
							onChange={text => {
								setOnReset(false);
								setFieldValue('endDate', text);
							}}
							onBlur={handleBlur}
							width={18}
							touched={touched.endDate}
							error={errors.endDate}
						/>
					</MimaFilter>
				)}
			</Formik>
            <div className={styles.upper}>
				<div className={styles.content}>
					<div className={styles.upper__metrics}>
						<BIC
							title="Total Commission"
							amount={amountFormatter().format(1000)}
							styleClass={styles.upper__metrics_discount}
						/>
						<BIC
							title="Total Approved Commissions"
							amount={amountFormatter().format(2000)}
							styleClass={styles.upper__metrics_paid}
							// onClick={() => viewFullyPaidInvoices()}
						/>

						<BIC
							title="Total Paid Commission"
							amount={amountFormatter().format(3000)}
							styleClass={styles.upper__metrics_partPaid}
							// onClick={() => viewPartiallyPaidInvoices()}
						/>

						<BIC
							title="Total Ignored Commission"
							amount={amountFormatter().format(2000)}
							styleClass={styles.upper__metrics_unpaid}
							// onClick={() => viewNotPaidInvoices()}
						/>

						<BIC
							title="Total UnPaid Commission"
							amount={amountFormatter().format(2000)}
							styleClass={styles.upper__metrics_unpaid}
							// onClick={() => viewNotPaidInvoices()}
						/>
						<BIC
							title="Total Tax Accrued "
							amount={amountFormatter().format(1000)}
							styleClass={styles.upper__metrics_vat}
							// onClick={() => viewInvoicesDueIn30Days()}
						/>

						<BIC
							title="Total Points Accrued"
							amount={11}
							styleClass={styles.upper__metrics_owe}
							// onClick={() => viewOverDueInvoices()}
						/>

						<BIC
							title="Total Transaction Amount"
							amount={amountFormatter().format(1000)}
							styleClass={styles.upper__metrics_discount}
						/>

					</div>
				</div>

				<div className={styles.upper__ql}>
					<MimaText variant="bodyBold">Quick Links</MimaText>
					<nav className={styles.upper__ql__content}>
						<QLC title="Create Commission Type" onClick={showComTypeModal}/>
						<QLC title="Upload Sales Sheet" onClick={showSaleSheetModal} />
					</nav>
				</div>
			</div>
            {/* <div className="searchInMiddle">
				<Searchbar
					placeholder="Search Invoices"
					variant="wide"
					// input={invoiceList}
					loading={false}
					// output={setFilteredInvoices}
					handleFilter={(item, searchQuery) => {
						return (
							item?.customer[0]?.fullname
								?.toLowerCase()
								?.includes(searchQuery) ||
							item?.number?.toLowerCase()?.includes(searchQuery)
						);
					}}
				/>
			</div> */}
            <MimaText mt={4} variant="bodyBold" align="center">You are viewing {tableType} Table </MimaText>
            <div className={styles.main_nav}>
				<div
					className={tableType === "Commissions" ? styles.main_nav_item_active : styles.main_nav_item}
					onClick={()=>{
                        setTableType("Commissions")
                    }}>
					Commissions
				</div>
				<div
					className={tableType === "Commission Summary" ? styles.main_nav_item_active : styles.main_nav_item}
					onClick={()=>{
                        setTableType("Commission Summary")
                    }}>
					Commission Summary
				</div>
				<div
					className={tableType === "Commission Type" ? styles.main_nav_item_active : styles.main_nav_item}
					onClick={()=>{
                        setTableType("Commission Type")
                    }}>
					Commission Type
				</div>
				<div
					className={styles.main_nav_item}
					onClick={() => {
					// 	downloadXlsx2(printData, `Transactions`);
					 }}>
					Download Report
				</div>

			</div>
            <div className="whiteTable">
                <MimaButton
                    title="Refresh"
                    variant="filter"
                    onClick={() => refresh()}
                    width={10}
                />
                {tableType === "Commissions" && (
                    <table>
                        <thead>
                            <tr>
                                <th> Employee </th>
								<th> Commission </th>
								<th> Commission Type </th>
                                <th> Tax </th>
                                <th> Period</th>
								<th> Point </th>
                                <th> Total Amount</th>
                                <th> Pay Day </th>
                                <th> Pay Date </th>
                                <th> Status </th>
                                <th> Action </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    Grace Abiola
                                </td>
								<td> 5,000 </td>
								<td> Collection </td>
                                <td>
                                    0
                                </td>
                                <td>
                                   Week-23-2022
                                </td>
								<td> 0 </td>
                                <td>
                                    50,000
                                </td>
                                <td>25/11/2022</td>
                                <td>25/11/2022</td>
                                <td>PAID</td>
                                <td className="action__text">Action</td>
                            </tr>
							<tr>
                                <td>
                                    Tosin Shodunke
                                </td>
								<td> 15,000 </td>
								<td> Collection </td>
                                <td>
                                    750
                                </td>
                                <td>
                                   Week-23-2022
                                </td>
								<td> 2 </td>
                                <td>
                                    50,000
                                </td>
                                <td>25/11/2022</td>
                                <td>25/11/2022</td>
                                <td>NOT PAID</td>
                                <td className="action__text">Action</td>
                            </tr>
							<tr>
                                <td>
                                    Phillip Tosin
                                </td>
								<td> 5,000 </td>
								<td> Sales </td>
                                <td>
                                    0
                                </td>
                                <td>
                                   Week-23-2022
                                </td>
								<td> 0 </td>
                                <td>
                                    50,000
                                </td>
                                <td>25/11/2022</td>
                                <td>25/11/2022</td>
                                <td>NOT PAID</td>
                                <td className="action__text">Action</td>
                            </tr>
							<tr>
                                <td>
                                    Nathaniel Shodunke
                                </td>
								<td> 10,000 </td>
								<td> Sales </td>
                                <td>
                                    500
                                </td>
                                <td>
                                   Week-23-2022
                                </td>
								<td> 2 </td>
                                <td>
                                    50,000
                                </td>
                                <td>25/11/2022</td>
                                <td>25/11/2022</td>
                                <td>NOT PAID</td>
                                <td className="action__text">Action</td>
                            </tr>
							<tr>
                                <td>
                                    Peter Abiola
                                </td>
								<td> 5,000 </td>
								<td> Installation </td>
                                <td>
                                    250
                                </td>
                                <td>
                                   Week-23-2022
                                </td>
								<td> 0 </td>
                                <td>
                                    10,000
                                </td>
                                <td>25/11/2022</td>
                                <td>25/11/2022</td>
                                <td>PAID</td>
                                <td className="action__text">Action</td>
                            </tr>
							<tr>
                                <td>
                                    Tosin Shodunke
                                </td>
								<td> 20,000 </td>
								<td> Installation </td>
                                <td>
                                    1,000
                                </td>
                                <td>
                                   Week-23-2022
                                </td>
								<td> 2 </td>
                                <td>
                                    60,000
                                </td>
                                <td>25/11/2022</td>
                                <td>25/11/2022</td>
                                <td>PAID</td>
                                <td className="action__text">Action</td>
                            </tr>
                        </tbody>
                    </table>
                )}


                {tableType === "Commission Summary" && (
                    <table>
                        <thead>
                            <tr>
                                <th> Employee </th>
                                <th> Period</th>
                                <th> Total Commission </th>
								<th> Total Points</th>
                                <th> Tax </th>
                                <th> Transaction Amount</th>
								<th> Pay Day </th>
								<th> Pay Date </th>
                                <th> Status </th>
                                <th> Action </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td> Peter Grace </td>
                                <td> Week-23-2022 </td>
                                <td> 23, 000 </td>
								<td> 25 </td>
                                <td> 0 </td>
                                <td> 50000</td>
								<td>25/11/2022</td>
                                <td>25/11/2022</td>
                                <td>PAID</td>
                                <td className="action__text"> Action </td>
                            </tr>
							<tr>
                                <td> Brown Ojulape </td>
                                <td> Week-23-2022 </td>
                                <td> 23, 000 </td>
								<td> 25 </td>
                                <td> 0 </td>
                                <td> 50000</td>
								<td>25/11/2022</td>
                                <td>25/11/2022</td>
                                <td>PAID</td>
                                <td className="action__text"> Action </td>
                            </tr>
							<tr>
                                <td> James Anjorin </td>
                                <td> Week-23-2022 </td>
                                <td> 25, 000 </td>
								<td> 27 </td>
                                <td> 0 </td>
                                <td> 50000</td>
								<td>25/11/2022</td>
                                <td>25/11/2022</td>
                                <td>PAID</td>
                                <td className="action__text"> Action </td>
                            </tr>
							<tr>
                                <td> Peter Oluwatobi </td>
                                <td> Week-23-2022 </td>
                                <td> 27, 000 </td>
								<td> 28 </td>
                                <td> 0 </td>
                                <td> 50000</td>
								<td>25/11/2022</td>
                                <td>25/11/2022</td>
                                <td>PAID</td>
                                <td className="action__text"> Action </td>
                            </tr>
							<tr>
                                <td> Afolabi Cynthia </td>
                                <td> Week-23-2022 </td>
                                <td> 23, 000 </td>
								<td> 25 </td>
                                <td> 0 </td>
                                <td> 70000</td>
								<td>25/11/2022</td>
                                <td>25/11/2022</td>
                                <td>PAID</td>
                                <td className="action__text"> Action </td>
                            </tr>
							<tr>
                                <td> Peter Brown </td>
                                <td> Week-23-2022 </td>
                                <td> 29, 000 </td>
								<td> 40 </td>
                                <td> 0 </td>
                                <td> 70000</td>
								<td>25/11/2022</td>
                                <td>25/11/2022</td>
                                <td>PAID</td>
                                <td className="action__text"> Action </td>
                            </tr> <tr>
                                <td> Samuel Grace </td>
                                <td> Week-23-2022 </td>
                                <td> 23, 000 </td>
								<td> 25 </td>
                                <td> 0 </td>
                                <td> 50000</td>
								<td>25/11/2022</td>
                                <td>25/11/2022</td>
                                <td>PAID</td>
                                <td className="action__text"> Action </td>
                            </tr>

                        </tbody>
                    </table>
                )}


                {tableType === "Commission Type" && (
                    <table>
                        <thead>
                            <tr>
                                <th> Commission Name </th>
                                <th> Target </th>
                                <th> Deduct Tax </th>
                                <th> Target Type</th>
                                <th> Base Target</th>
                                <th> Commission Target </th>
								<th> Fixed Amount </th>
                                <th>Commission Calculation</th>
                                <th>Disbursement Period</th>
                                <th> Status </th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td> Sales</td>
                                <td> 300,000 </td>
                                <td> false </td>
                                <td> VALUE </td>
                                <td> 0 </td>
                                <td>0 </td>
								<td>0 </td>
                                <td>Point</td>
                                <td>WEEKLY</td>
                                <td> active </td>
                                <td className="action__text">Action</td>
                            </tr>
							<tr>
                                <td> Collection</td>
                                <td> 10000 </td>
                                <td> false </td>
                                <td> VALUE </td>
                                <td> 0 </td>
                                <td>0 </td>
								<td>0 </td>
                                <td> Basic Rate</td>
                                <td>WEEKLY</td>
                                <td> active </td>
                                <td className="action__text">Action</td>
                            </tr>
							<tr>
                                <td> Installation</td>
                                <td> 450000 </td>
                                <td> true </td>
                                <td> VOLUME </td>
                                <td> 0 </td>
                                <td>0 </td>
								<td>1,500</td>
                                <td>Fixed</td>
                                <td>WEEKLY</td>
                                <td> active </td>
                                <td className="action__text">Action</td>
                            </tr>
                        </tbody>
                    </table>
                )}


		    </div>

            {(comTypeModal || saleSheetModal) && (
				<div className="modal">
					<AnimatePresence>
						{comTypeModal && (
							<CreateComTypeContainer
								closeModal={closeModal}
							/>
						)}
                        {saleSheetModal && (
							<SaleSheetUploadContainer
								closeModal={closeModal}
							/>
						)}
					</AnimatePresence>
				</div>
			)}
		</AppPage>
	);
};

export default Commission;
